/* TypeScript file generated from Nav.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as NavJS from './Nav.re.mjs';

export type props = {};

export const make: React.ComponentType<{}> = NavJS.make as any;

export const $$default: React.ComponentType<{}> = NavJS.default as any;

export default $$default;
